import { render } from "./InStoreOrderHistoryPage.vue?vue&type=template&id=4a8f5306"
import script from "./InStoreOrderHistoryPage.vue?vue&type=script&lang=js"
export * from "./InStoreOrderHistoryPage.vue?vue&type=script&lang=js"

import "./InStoreOrderHistoryPage.vue?vue&type=style&index=0&id=4a8f5306&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__